import React, { lazy } from 'react';
import { Button } from '../ui/Button';
export function HeroSection() {
  const scrollToPricing = () => {
    const el = document.getElementById('precio');
    if (!el) return;
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
    const delays = [300, 700, 1200];
    delays.forEach(ms => {
      setTimeout(() => {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, ms);
    });
  };
  return <section className="relative flex items-center pt-8 pb-8 md:pt-12 md:pb-10 overflow-hidden bg-background-dark" data-id="element-175">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[600px] bg-gradient-to-b from-[#3E1A00] to-transparent opacity-50 pointer-events-none" data-id="element-176" />

      <div className="container mx-auto px-4 relative z-10 flex flex-col items-center text-center" data-id="element-177">
        <div className="mb-4" data-id="element-178">
          <span className="inline-block border border-primary rounded-full py-1.5 px-5 text-primary tracking-widest uppercase text-[14px] font-[800]" data-id="element-179">
            🏋️ NUVORAPLUS
          </span>
        </div>

        <div className="max-w-4xl mx-auto" data-id="element-180">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black leading-tight mb-2 text-white font-heading" data-id="element-181">
            Dejá de improvisar.
          </h1>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black leading-tight mb-4 md:mb-5 font-heading" data-id="element-182">
            <span className="text-primary" data-id="element-183">Justificá, elegí y corregí</span>{' '}
            <span className="text-white" data-id="element-184">
              cada ejercicio con criterio profesional.
            </span>
          </h2>
        </div>

        {/* Image between heading and subtitle — smaller on mobile so heading stays as LCP */}
        <div className="w-full max-w-[280px] md:max-w-2xl mx-auto mb-4 bg-gradient-to-b from-[#2a1a0a] to-transparent rounded-2xl" data-id="element-185">
          <img src="https://cdn.magicpatterns.com/uploads/dy5gGg2GRuzzshTkgt6jjo/heylloyd-image-1772661952269.png" alt="Pack Bases del Entrenamiento de Fuerza" className="w-full h-auto drop-shadow-2xl" width={280} height={280} loading="lazy" decoding="async" style={{
          aspectRatio: '1 / 1'
        }} data-id="element-186" />
        </div>

        <div className="max-w-3xl mx-auto mb-5 md:mb-6" data-id="element-187">
          <p className="text-xl md:text-2xl font-medium text-gray-300" data-id="element-188">
            No alcanza con mostrar cómo se hace un ejercicio. El profesional que
            se <span className="text-primary font-bold" data-id="element-189">DESTACA</span> sabe
            explicarlo con{' '}
            <span className="text-primary font-bold" data-id="element-190">
              CRITERIO TÉCNICO REAL
            </span>
            .
          </p>
        </div>

        <div className="w-full max-w-4xl mx-auto mb-5 md:mb-8" data-id="element-191">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3" data-id="element-192">
            <div className="bg-card-dark rounded-xl p-3 flex items-center justify-center gap-2 border border-card-border-dark" data-id="element-193">
              <span className="text-xl" data-id="element-194">📄</span>
              <span className="text-sm md:text-base text-white font-medium" data-id="element-195">
                100% PDF
              </span>
            </div>
            <div className="bg-card-dark rounded-xl p-3 flex items-center justify-center gap-2 border border-card-border-dark" data-id="element-196">
              <span className="text-xl" data-id="element-197">⚡</span>
              <span className="text-sm md:text-base text-white font-medium" data-id="element-198">
                Acceso inmediato
              </span>
            </div>
            <div className="bg-card-dark rounded-xl p-3 flex items-center justify-center gap-2 border border-card-border-dark" data-id="element-199">
              <span className="text-xl" data-id="element-200">🎯</span>
              <span className="text-sm md:text-base text-white font-medium" data-id="element-201">
                Diseñá clases con lógica, no con intuición
              </span>
            </div>
            <div className="bg-card-dark rounded-xl p-3 flex items-center justify-center gap-2 border border-card-border-dark" data-id="element-202">
              <span className="text-xl" data-id="element-203">🧠</span>
              <span className="text-sm md:text-base text-white font-medium" data-id="element-204">
                Más autoridad profesional
              </span>
            </div>
          </div>
        </div>

        <div className="w-full max-w-2xl mx-auto" data-id="element-205">
          <div className="flex flex-col items-center gap-4" data-id="element-206">
            <Button onClick={scrollToPricing} className="w-full md:py-6 md:text-2xl" bounce={true} pulse={true} data-id="element-207">
              💪 QUIERO MI PACK A 19990$
            </Button>
            <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs md:text-sm text-gray-400" data-id="element-208">
              <span data-id="element-209">✅ Pago seguro | Garantía 7 días</span>
            </div>

            <div className="mt-4 grid grid-cols-3 gap-4 w-full text-center items-start" data-id="element-210">
              <div className="flex flex-col items-center" data-id="element-211">
                <div className="text-2xl md:text-3xl font-black text-primary font-heading h-[2.5rem] md:h-[3rem] flex items-center justify-center" data-id="element-212">
                  👨‍🏫 +570
                </div>
                <p className="text-xs md:text-sm text-gray-400 mt-2 min-h-[2.5rem] flex items-start justify-center" data-id="element-213">
                  profesionales lo usan
                </p>
              </div>
              <div className="flex flex-col items-center" data-id="element-214">
                <div className="text-2xl md:text-3xl font-black text-primary font-heading h-[2.5rem] md:h-[3rem] flex items-center justify-center" data-id="element-215">
                  💪 +140
                </div>
                <p className="text-xs md:text-sm text-gray-400 mt-2 min-h-[2.5rem] flex items-start justify-center" data-id="element-216">
                  ejercicios analizados
                </p>
              </div>
              <div className="flex flex-col items-center" data-id="element-217">
                <div className="text-2xl md:text-3xl font-black text-primary font-heading h-[2.5rem] md:h-[3rem] flex items-center justify-center" data-id="element-218">
                  ⭐ 4.9/5
                </div>
                <p className="text-xs md:text-sm text-gray-400 mt-2 min-h-[2.5rem] flex items-start justify-center" data-id="element-219">
                  calificación
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}